import React from 'react';
import NewsItem from "./NewsItem";
import '../NewsPage.css'

const NewsList = ({ news, onNewsUpdated, collectionName, dateFieldKey = 'date', editSource }) => {
    return (
        <table className='table table-bordered'>
            <thead className='thead-light'>
            <tr>
                <th>Название</th>
                <th>Дата</th>
                <th className='actions'>Действие</th>
            </tr>
            </thead>
            <tbody>
            {news.map(newsItem => (
                <NewsItem
                    key={newsItem.id}
                    news={newsItem}
                    onNewsUpdated={onNewsUpdated}
                    collectionName={collectionName}
                    dateFieldKey={dateFieldKey}
                    editSource={editSource}
                />
            ))}
            </tbody>
        </table>
    );
};

export default NewsList;
